import { NormalizedBookingInfo, NormalizedJoyPlace, NormalizedTravelReservationBookingDetailsQuery } from './GuestHotelBookingsList.types';

export const bookingReservationFallback: NormalizedTravelReservationBookingDetailsQuery = {
  travelReservationBookingDetails: [
    {
      bookingInfo: [],
      joyPlace: {} as NormalizedJoyPlace,
    },
  ],
};

export const bookingInfoFallback: NormalizedBookingInfo = {
  id: '',
  checkInDate: null,
  checkOutDate: null,
  email: '',
  status: null,
  // fallback to handle null values while sorting the records
  bookingDate: new Date().toISOString(),
  firstName: '',
  lastName: '',
  occupancy: {
    adults: 0,
    children: 0,
  },
  roomTypes: [],
};

export const joyPlaceFallback: NormalizedJoyPlace = {
  id: '',
  starRating: 0,
  name: '',
  lat: 0,
  long: 0,
  photo: {
    id: '',
    url: '',
  },
};
